import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  UsuariosSistemaClave
} from "@fixeduy/restaurantestypes";

const agregarUsuarioConClave = async (
  data: UsuariosSistemaClave
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "agregarUsuarioConClave",
    params: data
  });
  return result.data;
};

export { agregarUsuarioConClave };
